import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  ProductAttributes,
  UpdateProductAttributesPayload
} from "../../recommendation.types";
import { requestUpdateProductAttributes } from "./updateProductAttributes.request";

const useUpdateProductAttributes = (
  options?: MutationOptions<
    ProductAttributes,
    ApiServiceError<ApiError>,
    { id: string; payload: UpdateProductAttributesPayload }
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateProductAttributes,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "enrichment"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateProductAttributes;
